import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "../firebase";
import { logEvent } from "firebase/analytics";
import { captureMarketingAttribution } from "../services/marketingAttribution";
import { initializeTracking, trackPageViewWithGoogleTag } from "../services/googleTag";

export default function AnalyticsListener() {
  const location = useLocation();

  useEffect(() => {
    initializeTracking();
  }, []);

  useEffect(() => {
    const pagePath = location.pathname + location.search;
    captureMarketingAttribution(location.pathname, location.search);
    if (analytics) {
      logEvent(analytics, "page_view", { page_path: pagePath });
      return;
    }
    trackPageViewWithGoogleTag(pagePath);
  }, [location]);
  return null;
}
